// Shared time-range + bucket-interval controls for the Cost section. Mirrors
// the range/interval pattern used by the apigen Statistics page so the Cost
// pages feel consistent with the rest of the SPA ("breakable by time").

export type RangeKey = '24h' | '7d' | '30d';
export type IntervalKey = '5m' | '15m' | '1h' | '6h' | '1d';

export const RANGE_LABELS: Record<RangeKey, string> = {
  '24h': 'Last 24h',
  '7d': '7 days',
  '30d': '30 days',
};

export const RANGE_MS: Record<RangeKey, number> = {
  '24h': 24 * 60 * 60_000,
  '7d': 7 * 24 * 60 * 60_000,
  '30d': 30 * 24 * 60 * 60_000,
};

export const INTERVAL_LABELS: Record<IntervalKey, string> = {
  '5m': '5 min',
  '15m': '15 min',
  '1h': '1 hour',
  '6h': '6 hours',
  '1d': '1 day',
};

export const INTERVAL_MS: Record<IntervalKey, number> = {
  '5m': 5 * 60_000,
  '15m': 15 * 60_000,
  '1h': 60 * 60_000,
  '6h': 6 * 60 * 60_000,
  '1d': 24 * 60 * 60_000,
};

export const DEFAULT_INTERVAL: Record<RangeKey, IntervalKey> = {
  '24h': '5m',
  '7d': '6h',
  '30d': '1d',
};

/** Format a USD amount for display, scaling precision to the magnitude. */
export function formatUsd(value: number): string {
  if (!value || value <= 0) return '$0';
  if (value < 0.01) return `$${value.toFixed(5)}`;
  if (value < 1) return `$${value.toFixed(4)}`;
  return `$${value.toFixed(2)}`;
}
